import React, { useEffect, useState } from 'react';

import { setBreadcrumbs } from '../../../../../../../redux/Admin/breadcrumbsSlice';
import { useDispatch, useSelector } from 'react-redux';

import { useLocation } from 'react-router-dom';
import EmployeeSessionView from './EmployeeSessionView';

const EmployeeView = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isLocked, setIsLocked] = useState(true);
  const dispatch = useDispatch();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const employeeId = searchParams.get('empId');
  const tab = searchParams.get("tab");
  const sessionId = searchParams.get("sessionId");
  const sessionView = searchParams.get('sessionView');
  const companyId = searchParams.get('companyId');
  console.log(employeeId, "employeeIdemployeeId")
  const storedManagementName = useSelector((state) => state.managementView?.managementName);
  const storedSessionName = useSelector((state) => state.sessionView?.sessionName);

  // ✅ Breadcrumbs: keep consistent with Management View base
  useEffect(() => {
    // Breadcrumbs when coming from Company view
  if (location.pathname.includes('/companies/companyview')) {
      dispatch(
        setBreadcrumbs([
          { label: "Companies", url: "/companies", home: "/companies" },
          { label: "View Company", url: `/companies/companyview?companyId=${companyId}&tab=management` },
      { label: storedManagementName || "View Management", url: `/companies/companyview?companyId=${companyId}&tab=managementOverview&empId=${employeeId}&view=true` },
      { label: storedSessionName || 'Session View', url: `/companies/companyview?companyId=${companyId}&tab=managementSessions&empId=${employeeId}&sessionId=${sessionId}&companySessionView=view` },
        ])
      );
      return;
    }

    const effectiveTab = tab || 'managementOverview';
    const baseUrl = `/management/view?empId=${employeeId}&tab=${effectiveTab}`;
    const crumbs = [
      { label: 'Management', url: '/management', home: '/companies' },
      { label: storedManagementName || 'View Management', url: baseUrl },
    ];

    if (sessionView) {
      crumbs.push({
  label: storedSessionName  || 'Session View',
        url: `${baseUrl}&sessionId=${sessionId}&sessionView=view`,
      });
    }

    dispatch(setBreadcrumbs(crumbs));
  }, [sessionId, tab, employeeId, sessionView, dispatch, storedManagementName ,storedSessionName]);

  // ✅ Keep tab synced
  useEffect(() => {
    if (sessionView === "view") {
      setActiveTab('sessions');
    }
  }, [sessionView]);

  return (
    <div>
      <div className="flex justify-between mb-5">
        <div className="w-full">

          <EmployeeSessionView />

        </div>
      </div>
    </div>
  );
};

export default EmployeeView;
